export default "__VITE_ASSET__WDyeb4Pm__"